define((require) => {
    "use strict";

    var EditorActivity  = require("editor/ui/experience/editor/activity/EditorActivity"),
        Backbone        = require("backbone"),
        GeneralFunctions = require("editor/util/GeneralFunctions");

    /**
     * Takes an object of attributes and returns a new object where any model values are cloned
     * instead of just having a reference.
     *
     * Note, clone does not need to be called any deeper, as it already have this functionality
     * built into it. The only reason we need this function, is that we are working with Objects
     * instead of Models.
     *
     * @private
     * @stateless
     * @param {Object} attributes Object that we wish to clone
     * @returns {Object}          Object with model values cloned.
     */
    var cloneValues = GeneralFunctions.mapOverObj((value) => {
        return (value instanceof Backbone.Model) ? value.clone({duplicate: true}) : value;
    });

    /**
     * An activity representing a change in one or more widget properties.
     *
     * @class WidgetPropertiesChangedActivity
     * @author Kim
     */
    return EditorActivity.extend({

        _widgetModel: null,

        _changedAttributes: null,

        _previousAttributes: null,

        constructor: function(widgetModel, changedAttributes, previousAttributes) {
            this._widgetModel = widgetModel;
            this._changedAttributes = changedAttributes;
            this._previousAttributes = previousAttributes;
        },

        _onUndo: function() {
            // Add the 'cause' to signal that the change came from a undo action
            this._widgetModel.set(cloneValues(this._previousAttributes), {cause: "undo"});
        },

        _onRedo: function() {
            // Add the 'cause' to signal that the change came from a redo action
            this._widgetModel.set(cloneValues(this._changedAttributes), {cause: "redo"});
        },

        dispose: function() {
            this._widgetModel = null;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/activity/WidgetPropertiesChangedActivity.js